module.exports = __webpack_public_path__ + "img/agricultura-familiar-ba.d21b0f9b.png";